<template>
  <div v-if="value">
    <div
      class="modal d-block"
      tabindex="-1"
      role="dialog"
      aria-modal="true"
      @mousedown.self="close"
    >
      <div
        class="modal-dialog modal-dialog-scrollable"
        :class="size ? `modal-${size}` : ''"
        role="document"
      >
        <!-- text-left: a diferencia de b-modal (que se monta en el body), este modal se
             renderiza dentro de #app y heredaría su text-align: center (App.vue) -->
        <div class="modal-content text-left">
          <div class="modal-header">
            <h5 class="modal-title">{{ title }}</h5>
            <button
              type="button"
              class="close"
              :aria-label="closeLabel"
              @click="close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <slot></slot>
          </div>
          <div v-if="$slots.footer" class="modal-footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop show"></div>
  </div>
</template>

<script setup>
// Modal con las clases de Bootstrap 4, sin Bootstrap-Vue ni el JS de Bootstrap (requiere
// jQuery, que no está cargado). Se controla con v-model y se cierra con Esc, la X o un
// clic en el fondo.
import { onBeforeUnmount, watch } from "vue";

const props = defineProps({
  value: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: "",
  },
  // "sm", "lg" o "xl" (clases modal-*)
  size: {
    type: String,
    default: "",
  },
  closeLabel: {
    type: String,
    default: "Close",
  },
});
const emit = defineEmits(["input", "hidden"]);

function close() {
  emit("input", false);
}

function onKeydown(event) {
  if (event.key === "Escape") close();
}

// Solo toca el body cuando este modal cambia de estado: montarlo cerrado no debe quitar el
// modal-open de un modal de Bootstrap-Vue que esté abierto.
let is_open = false;
function setOpen(open) {
  if (open === is_open) return;
  is_open = open;
  document.body.classList.toggle("modal-open", open);
  if (open) document.addEventListener("keydown", onKeydown);
  else document.removeEventListener("keydown", onKeydown);
}

watch(
  () => props.value,
  (open, was_open) => {
    setOpen(open);
    if (was_open && !open) emit("hidden");
  },
  { immediate: true }
);

onBeforeUnmount(() => setOpen(false));
</script>
